module.exports = __webpack_public_path__ + "img/2.ff07b79a.jpg";